import { z } from 'zod';

// Любой API-эндпоинт: опиши тут zod-схему ответа, выведи тип через z.infer,
// и используй ОДНУ и ТУ ЖЕ схему на сервере (валидация ответа) и на клиенте
// (валидация полученного JSON). Так клиент и сервер не разойдутся в контракте.

export const HelloResponseSchema = z.object({
  message: z.string(),
  timestamp: z.string().datetime(),
});
export type HelloResponse = z.infer<typeof HelloResponseSchema>;

// --- Notes ---

export const NoteSchema = z.object({
  id: z.number().int().positive(),
  title: z.string(),
  content: z.string(),
  createdAt: z.string(),
});
export type Note = z.infer<typeof NoteSchema>;

export const NotesResponseSchema = z.array(NoteSchema);

export const CreateNoteInputSchema = z.object({
  title: z.string().min(1).max(200),
  content: z.string().max(10_000).optional(),
});
export type CreateNoteInput = z.infer<typeof CreateNoteInputSchema>;
